module.exports = __webpack_public_path__ + "img/2_diamond.d9910e4f.jpg";